const Constant = {
  // API_URL: 'http://localhost:62378/',
  API_URL: 'https://apicac.ihct.mx/',
  PAGE_SIZE: 10,
}

export default Constant
